import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue, useApprovalsData } from 'content-management-data-lib';
import { View } from 'foundations-components/transitional/components/View';
import { ApprovalStatus, ApprovalStatusTag } from 'ui-product-approvals';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalValueToStatus = {
  'No Approval Requested': 'default',
  approved: ApprovalStatus.APPROVED,
  pending: ApprovalStatus.APPROVAL_PENDING
};
const ContentApprovalStatusTag = ({
  contentObject
}) => {
  const {
    areApprovalsEnabled
  } = useApprovalsData();
  const approvalStatus = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.APPROVAL_PUBLISH_STATUS); // TODO: validate correct values returned from BE

  if (!areApprovalsEnabled) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    marginInlineStart: "200",
    marginBlockStart: "200",
    children: /*#__PURE__*/_jsx(ApprovalStatusTag, {
      approvalStatus: ApprovalValueToStatus[approvalStatus],
      longform: true
    })
  });
};
export default ContentApprovalStatusTag;